import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const handleClick = () => {
    const el = document.getElementById('final-cta');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~80% of the first viewport (past hero)
      const threshold = window.innerHeight * 0.9;
      const nearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 600;
      setVisible(window.scrollY > threshold && !nearBottom);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-187">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 z-50 px-3 pb-3 pointer-events-none" data-id="element-188">
          <div className="pointer-events-auto max-w-4xl mx-auto bg-cosmic-800/95 backdrop-blur-md border border-amber-500/30 rounded-xl shadow-[0_-5px_30px_rgba(0,0,0,0.5),0_0_25px_rgba(245,197,66,0.15)] px-4 py-3 md:px-6 md:py-4 flex items-center justify-between gap-3 md:gap-6" data-id="element-189">
            {/* Left: book + price */}
            <div className="flex items-center gap-3 md:gap-4 min-w-0" data-id="element-190">
              <img src="https://cdn.magicpatterns.com/uploads/rT81seYCUHiK6wFwJax7qT/Imagen.png" alt="DMT: La Molécula de Dios" className="hidden sm:block w-10 h-14 md:w-12 md:h-16 object-cover rounded-sm shadow-md flex-shrink-0" data-id="element-191" />
              <div className="min-w-0" data-id="element-192">
                <p className="font-serif text-amber-400 text-sm md:text-base font-semibold leading-tight truncate" data-id="element-193">
                  DMT: La Molécula de Dios
                </p>
                <div className="flex items-baseline gap-2 mt-0.5" data-id="element-194">
                  <span className="text-xs md:text-sm text-gray-500 line-through font-serif" data-id="element-195">
                    $108
                  </span>
                  <span className="text-xl md:text-2xl font-serif font-bold text-amber-400" data-id="element-196">
                    $27 USD
                  </span>
                  <span className="hidden md:inline-block px-2 py-0.5 text-[10px] font-bold tracking-widest text-cosmic-900 uppercase bg-amber-400 rounded-full" data-id="element-197">
                    -75%
                  </span>
                </div>
              </div>
            </div>

            {/* Right: CTA */}
            <motion.button onClick={handleClick} whileHover={{
          scale: 1.03,
          boxShadow: '0 0 25px rgba(245, 197, 66, 0.5)'
        }} whileTap={{
          scale: 0.97
        }} className="flex-shrink-0 bg-gradient-to-b from-amber-400 to-amber-600 text-cosmic-900 font-serif font-bold text-sm md:text-lg px-4 py-3 md:px-7 md:py-3.5 rounded-sm tracking-wide shadow-[0_0_15px_rgba(245,197,66,0.3)] whitespace-nowrap cursor-pointer" data-id="element-198">
              Comenzar el Viaje <span className="ml-1" data-id="element-199">→</span>
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};